import { LocalTypeInteractor, LocalTypeRequest, LocalTypeStructRequest } from "../../Coordinator/LocalType/LocalTypeInteractor";

export class LocalTypeViewModel {
	private interactor: LocalTypeInteractor;

	constructor() {
		this.interactor = new LocalTypeInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new LocalTypeRequest(
			obj["sgeptipolocal"] ? parseInt(obj["sgeptipolocal"]) : 0,
			obj["nome"] ? obj["nome"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new LocalTypeStructRequest(obj["sgeptipolocal"] ? parseInt(obj["sgeptipolocal"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}